// extracted by mini-css-extract-plugin
module.exports = {"fields":"DateFieldCustom_fields__1dxwt","field":"DateFieldCustom_field__35v74"};